import { collection, getDocs, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

// ✅ Get all users
export const fetchAllUsers = async () => {
  const snapshot = await getDocs(collection(db, "users"));
  const users = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data()
  }));
  return users;
};

// ✅ Update a user's data (DP or pseudo)
export const updateUserField = async (userId, field, value) => {
  // Use backup wrapper for admin updates
  const { updateUserProfileWithBackup } = await import('../utils/clientBackupWrapper');
  
  await updateUserProfileWithBackup(userId, {
    [field]: value
  }, 'admin_update', {
    field: field,
    newValue: value,
    updatedBy: 'admin'
  });
};

// ✅ Create a new user with manual UID (no password saved)
export const createUserManually = async (uid, pseudo, dp, facebookLink = '') => {
  const userRef = doc(db, "users", uid);
  await setDoc(userRef, {
    pseudo,
    dp,
    facebookLink,
    createdAt: new Date().toISOString()
  });
};

